import CommonValidation from '../../../utils/common.validation';

class Validation {
  static formValidate = (type, value, propriety, reject) => {
    if (type === 'orderRejectCode' && propriety === 0) {
      return CommonValidation.requiredSelect(value);
    }
    if (type === 'shopProprietyRemarks' && (propriety === 2 || (propriety === 0 && reject === 99))) {
      return CommonValidation.requiredValue(value);
    }
    return '';
  };
}

export default Validation;
